import React from "react"
import Icon from "../Icon"
import styles from "./IconBadge.module.css"

const IconBadge = ({icon=""}) => <div className={styles.container}><Icon icon={icon}/></div>

export default IconBadge